export const OSAKA_JAPAN = "Osaka, Japan";

export const BASIC_DESIGN = "Basic design";
export const DETAIL_DESIGN = "Detail design";
export const CODING = "Coding";
export const UNIT_TEST = "Unit test";
export const INTEGRATION_TEST = "Integration test";
export const SYSTEM_TEST = "System test";

export const HTML_CODER = "HTML coder";

export const HTML5 = "HTML5";
export const CSS3 = "CSS3";
export const SASS = "SASS";
export const JAVA_SCRIPT = "JavaScript";
export const J_QUERY = "jQuery";
export const REACT = "React.js";

export const JAVA = "Java";
export const PHP = "PHP";
export const WORDPRESS = "WordPress";
export const GULP = "gulp";
export const WEBPACK = "webpack";
export const NPM = "npm";

export const NODE = "Node.js";
export const EXPRESS = "Express";
export const GRAPHQL = "Graphql";
export const SOCKET_IO = "Socket.IO";

export const SQL_SERVER = "SQL Server";
export const POSTGRE_SQL = "PostgreSQL";
export const ORACLE_DB = "Oracle DB";
export const MY_SQL = "MySQL";

export const GIT = "Git";
export const GITHUB = "GitHub";
export const GITLAB = "GitLab";

export const DOCKER = "Docker";
export const TOMCAT = "Tomcat";
export const AWS = "AWS";
export const FIREBASE = "Firebase";

export const VBA = "VBA";

export const OFFSET_WORK_LOG = "75";
export const OFFSET_TOOL_SET = "80";
export const OFFSET_SIDE_PROJECTS = "70";

export const GITHUB_URL = "https://github.com/Naoto-110616/portfolio";
export const LINKED_IN = "https://www.linkedin.com/in/naoto-okawa-289756223/";
